import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AnimatedBack from "../images/AnimatedBack.gif";
import BlockChain from "../images/Blockchain.png";
import AnimatedBlockchain from "../images/AnimatedBlockchain.gif";
import B1 from "../images/B1.png";
import B2 from "../images/B2.png";
import B3 from "../images/B3.png";
import B4 from "../images/B4.png";
import B5 from "../images/B5.png";
import B6 from "../images/B6.png";
import "../css/Blockchain.css";

function Blockchain() {
  return (
    <>
      <Header />
      <div className="GD">
        {/* Top Section */}
        <div className="Webd-above">
          <img className="Webd-img" src={AnimatedBack} alt="" />
          <div className="Webd-above-info">
            <p className="Webd-p mt-lg">Blockchain & NFT</p>
            <p className="Webd-p1">
              It provides robust data security within a secure open-source
              environment, utilizing advanced cryptographic mechanisms to
              safeguard your information.
            </p>
          </div>
        </div>

        {/* Main section */}
        <div className="Webdesign-main1 section-spacing">
          <div className="Webdesign-info">
            <p>
              Blockchain technology is quickly establishing itself as a key
              player in software development, particularly in blockchain
              development, and is set to define the future of web application
              development. The decentralized nature of blockchain ensures that
              data is secure, with every transaction being time-stamped for
              added verification. Whether it's for selling, purchasing, funding,
              or other activities, blockchain provides a secure and transparent
              way to handle value, making it an invaluable tool for businesses
              and developers alike.
            </p>

            <p>
              Our software developers create high-quality websites powered by
              blockchain technology and digital transaction records, positioning
              us as market leaders. With the growth of the Bitcoin blockchain
              trade, blockchain is set to be the future of global digital
              currencies. Purohit Technosoft developers worldwide are working on
              innovative cryptocurrency websites, building the next generation
              of blockchain networks.
            </p>

            <p>
              An NFT (Non-Fungible Token) is a unique data unit that verifies
              the originality of a digital asset on the blockchain. Its
              non-fungible nature ensures that it cannot be exchanged for
              something else, guaranteeing the uniqueness of the data it
              represents. This irreplaceable characteristic has fueled the
              global rise in NFT usage. Shri Genesis is committed to being your
              trusted NFT development partner, offering a stable platform for
              NFT transactions. We act as the backbone of your blockchain
              solutions, enabling you to streamline services more efficiently.
            </p>
          </div>

          <img
            className="Webdesign-main1-img"
            src={BlockChain}
            alt="Blockchain Illustration"
          />
        </div>

        {/* Animated Blockchain Section */}
        <div className="section-spacing text-center">
          <img
            className="animated-img"
            src={AnimatedBlockchain}
            alt="Animated Blockchain"
          />
        </div>

        {/* Services Section */}
        <div className="Webd-main2 section-spacing">
          <p className="Webd-main2-p">Blockchain Development Solutions</p>
          <p className="Webd-main2-p1">
            At Purohit Technosoft, we offer expert blockchain and NFT
            development services designed to meet the needs of modern
            businesses. Below are some of the core services we deliver.
          </p>

          {/* Row 1 */}
          <div className="Webd-main2-boxes">
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={B1} alt="" />
              <p className="box-title">Supply Chain Solutions</p>
              <p>
                Eliminating inefficient information access channels to optimize
                supply chain management, ensuring faster decision-making,
                greater transparency, and improved overall efficiency.
              </p>
            </div>
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={B2} alt="" />
              <p className="box-title">Smart Contract Solutions</p>
              <p>
                Empowering blockchain to validate every transaction or change,
                ensuring that all actions are traceable back to their origin for
                enhanced transparency and accountability.
              </p>
            </div>
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={B3} alt="" />
              <p className="box-title">Hyperledger Solutions</p>
              <p>
                Hyperledger streamlines processes by delivering secure,
                transparent, and detailed information, ensuring data integrity
                while simplifying complex transactions across blockchain
                networks.
              </p>
            </div>
          </div>

          {/* Row 2 */}
          <div className="Webd-main2-boxes">
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={B4} alt="" />
              <p className="box-title">Blockchain IoT Solutions</p>
              <p>
                Connect peripherals to the blockchain to create an impregnable
                system, protecting against threats and malware by ensuring data
                integrity and security at every point of interaction.
              </p>
            </div>
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={B5} alt="" />
              <p className="box-title">POC Development</p>
              <p>
                Utilizing smart contracts to develop proofs-of-concept, while
                aligning resources and technologies to enhance process
                efficiency and ensure seamless execution of automated tasks.
              </p>
            </div>
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={B6} alt="" />
              <p className="box-title">Private Blockchain Development</p>
              <p>
                Designing a customized blockchain solution for a specific
                industry, streamlining implementation and optimizing
                effectiveness to meet the unique requirements of the sector.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Blockchain;
